/** The gun in your hands, and the one a raid is planned around. */

import type { EquipmentSlot } from '@/sim/inventory/slotContract';

export const PRIMARY_WEAPON_SLOT = {
  id: 'primaryWeapon',
  label: 'Primary weapon',
  description: 'The gun in your hands, and the one a raid is planned around.',
} as const satisfies EquipmentSlot;
